export const ColumnHeader = [
  "Geography Level",
  "Status",
  "Enrichment Confidence Flag",
  "State Name",
  "Pincode",
  "Locality Name",
  "Socio-Economic Profile: Income",
  "Regio-type",
  "Inner City Regio-type",
  "Consumer Segments: Lifestyle",
  "Consumer Segments: SEC Reference",
  // "Consumer Segments: Lifestyle > Smaller Towns",
  "Consumer Segments: Special Health Care Target Group",
  "Financial > Insurance: Saving Plan",
  "Financial > Insurance: Retirement Plan",
  "Financial > Insurance: Unit Linked Plan",
  // "Financial > Insurance: Health",
  "Financial > Banking: Mutual Fund",
  "Financial > Banking: Fixed Deposit",
  "Financial > Banking: Credit Card Holding",
  "Automobile: 01: Entry Price - Segment INR 4,00,000 - 7,00,000",
  "Automobile: 02: Entry Premium Hatch Segment INR 6,00,000 - 10,00,000",
  "Automobile: 03: Premium Hatch Segment INR 7,00,000 - 11,00,000",
  "Automobile: 04: Compact Sedan Segment INR 6,00,000 - 10,00,000",
  "Automobile: 05: Sedan Segment INR 10,00,000 - 17,50,000",
  "Automobile: 06: Premium Sedan Segment INR 16,00,000 - 25,00,000",
  "Automobile: 07: Compact / Entry SUV Segment INR 6,00,000 - 14,00,000",
  "Automobile: 08: SUV Segment INR 20,00,000 – 45,00,000",
  "Automobile: 09: Luxury Premium Sedan & SUV Segment INR 45,00,000+",
  "Automobile: 10: Second-hand Sedan Segment car",
  "Automobile: 11: Second-hand Premium Sedan / SUV Segment",
  "Automobile: 12: Second-hand Luxury Premium Sedan & SUV Segment",
  "Real Estate: Purchase Price Segment",
  "FMCG: Laundry > Fabric Wash Products",
  "FMCG: Laundry > Washing Machine Products",
  "FMCG: Personal Wash",
  "FMCG: Packaged Food",
  "FMCG: Cosmetics",
  "Fashion & Apparel: Purchase Price Category",
  "Jewellery & Gold: Purchase Category > Total",
  "Jewellery & Gold: Purchase Category > Gold",
  "Jewellery & Gold: Purchase Category > Diamond",
  "Travel > Short Term: Spend Category",
  "Travel > Long Term: Destination Category",
  "Travel > Long Term: Special Category",
  "Retail: Online Shopping Channels",
  "Retail: Product Category Home and Living",
  "Two Wheeler: 01: Entry Level Scooter Segment",
  "Two Wheeler: 02: Premium Scooter Segment",
  "Two Wheeler: 03: Entry Level Commuter Segment",
  "Two Wheeler: 04: Premium Commuter Segment",
  "Two Wheeler: 05: Entry Level Sports Bike Segment",
  "Two Wheeler: 06: Premium Sports Bike Segment",
  "Two Wheeler: 07: Entry Level Cruiser Bike Segment",
  "Two Wheeler: 08: Premium Cruiser Bike Segment",
  "Two Wheeler: 09: Touring Bike Segment",
  "Two Wheeler: 10: Off Road Bike Segment",
  "Economic Comparison Score (Level 1: Micro)",
  "Economic Comparison Score (Level 2: Macro)",
  "Psychographic Profile Comparison (Level 1: Micro)",
  "Psychographic Profile Comparison (Level 2: Macro)",
  // "Psychographic Profile GeoScore (Level 1: Micro)",
  // "Psychographic Profile GeoScore (Level 2: Macro)"

];

export const Encodingkeys = [
  "geography_level",
  "status",
  "A0",
  "A1",
  "A2",
  "A3",
  "B",
  "C",
  "C_I",
  "D",
  "E",
  // "F",
  "G1",
  "G2",
  "G3",
  "G4",
  // "G5",
  "G6",
  "G7",
  "G8",
  "G9",
  "G10",
  "G11",
  "G12",
  "G13",
  "G14",
  "G15",
  "G16",
  "G17",
  "G18",
  "G19",
  "G20",
  "G21",
  "G22",
  "G23",
  "G24",
  "G25",
  "G26",
  "G27",
  "G28",
  "G29",
  "G30",
  "G31",
  "G32",
  "G33",
  "G34",
  "G35",
  "G36",
  "G37",
  "G38",
  "G39",
  "G40",
  "G41",
  "G42",
  "G43",
  "G44",
  "G45",
  "IDS1",
  "IDS2",
  "LSC1",
  "LSC2",
  // "LDC1",
  // "LDC2"
];

export const escapeDoubleQuotes = (value) => {
  return value.replace(/"/g, '""');
};

export const replaceEncodingIssue = (value) => {
  return value.replace(/–/g, "-"); // Replace the problematic encoding '–' with '-'
};
